module.exports = __webpack_public_path__ + "img/pix2.019a2d16.png";